module.exports = __webpack_public_path__ + "img/gridsome_plugin_preview.ca044ac5.png";